import * as z from "zod/v4";
import {
  createOrderEditInputSchema,
  createOrderEditOutputSchema,
} from "./base";

/**
 * Schema for updating order shipping address
 */

// Reusable shipping address type
const ShippingAddress_ = z.object({
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  address1: z.string().describe("Street address line 1"),
  address2: z.string().optional(),
  city: z.string().optional(),
  provinceCode: z.string().optional(),
  zip: z.string().optional(),
  countryCode: z.string().optional(),
});

export const ShippingAddressSchema: z.ZodType<ShippingAddress> =
  ShippingAddress_;
export interface ShippingAddress extends z.infer<typeof ShippingAddress_> {}

// Data schema for address update
const UpdateAddressData_ = z.object({ shippingAddress: ShippingAddressSchema });

export const UpdateAddressDataSchema: z.ZodType<UpdateAddressData> =
  UpdateAddressData_;
export interface UpdateAddressData extends z.infer<typeof UpdateAddressData_> {}

// Full input schema
const UpdateAddressInput_ = createOrderEditInputSchema(UpdateAddressDataSchema);

export const UpdateAddressInput: z.ZodType<UpdateAddressInput> =
  UpdateAddressInput_;
export interface UpdateAddressInput
  extends z.infer<typeof UpdateAddressInput_> {}

// Output data schema
const UpdateAddressOutputData_ = ShippingAddressSchema;

export const UpdateAddressOutputDataSchema: z.ZodType<UpdateAddressOutputData> =
  UpdateAddressOutputData_;
export interface UpdateAddressOutputData
  extends z.infer<typeof UpdateAddressOutputData_> {}

// Output metadata schema
const UpdateAddressOutputMetadata_ = z.object({
  validationDetails: z
    .object({
      validated: z.boolean(),
      possibleAddresses: z.array(ShippingAddressSchema).optional(),
    })
    .optional(),
});

export const UpdateAddressOutputMetadataSchema: z.ZodType<UpdateAddressOutputMetadata> =
  UpdateAddressOutputMetadata_;
export interface UpdateAddressOutputMetadata
  extends z.infer<typeof UpdateAddressOutputMetadata_> {}

// Full output schema
const UpdateAddressOutput_ = createOrderEditOutputSchema(
  UpdateAddressOutputDataSchema,
  UpdateAddressOutputMetadata_,
);

export const UpdateAddressOutput: z.ZodType<UpdateAddressOutput> =
  UpdateAddressOutput_;
export interface UpdateAddressOutput
  extends z.infer<typeof UpdateAddressOutput_> {}
